@if (showNavbar$()) {
  <!-- App-level banners render before the navigation so required messages push the full shell down. -->
  <lab-banner-host />

  <div class="lab-app-container">
    <div class="lab-app-navbar">
      <lab-navbar name="Wolfie" />
    </div>
    <div class="lab-app-content" data-shortcut-layer="content">
      <lab-page>
        @if (activeRouteStatus$() === 'loading') {
          <lab-loader [loader]="SolLoader.ofBlocks(3).withMargin('0')" />
        } @else if (activeRouteStatus$() === 'forbidden') {
          <lab-error-page [type]="SolErrorPageType.FORBIDDEN" />
        } @else {
          <router-outlet />
        }
      </lab-page>
    </div>
  </div>
} @else {
  @if (activeRouteStatus$() === 'loading') {
    <lab-loader [loader]="SolLoader.ofBlocks(3)" />
  } @else if (activeRouteStatus$() === 'forbidden') {
    <lab-error-page [type]="SolErrorPageType.FORBIDDEN" />
  } @else {
    <router-outlet />
  }
}
<lab-overlays />
<lab-command-palette />
